import { createEvent, createStore } from "effector";
import { audio } from "frontend/src/domain/audio";
import { $activeWebSchedule } from "frontend/src/features/play-web-schedule";
export var setTimetableInterruptions = createEvent();
export var clearTimetableInterruptions = createEvent();
export var resetTimetableInterruption = createEvent();
export var timetableInterruptionStarted = createEvent();
export var timetableInterruptionFinished = createEvent();
export var $isTimetableInterruptionPlaying = createStore(false)
    .on(timetableInterruptionStarted, function () { return true; })
    .reset(timetableInterruptionFinished)
    .reset(resetTimetableInterruption);
export var $activeTimetableInterruptionTrack = createStore(null)
    .on(timetableInterruptionStarted, function (_, payload) { return payload; })
    .reset(timetableInterruptionFinished)
    .reset(resetTimetableInterruption);
var timers = [];
var activeRestore = null;
var clearTimers = function () {
    timers.forEach(function (timer) { return window.clearTimeout(timer); });
    timers = [];
};
var playInterruption = function (track) {
    var _a, _b;
    if (activeRestore || !track.url) {
        return;
    }
    activeRestore = {
        src: audio.src,
        currentTime: audio.currentTime,
        wasPlaying: !audio.paused,
    };
    timetableInterruptionStarted({
        track: track,
        scheduleTitle: (_b = (_a = $activeWebSchedule.getState()) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : null,
    });
    audio.pause();
    audio.src = track.url;
    audio.currentTime = 0;
    audio.play();
};
setTimetableInterruptions.watch(function (items) {
    clearTimers();
    timers = items.map(function (item) {
        return window.setTimeout(function () { return playInterruption(item.track); }, Math.max(0, item.offsetSeconds * 1000));
    });
});
clearTimetableInterruptions.watch(function () {
    clearTimers();
});
resetTimetableInterruption.watch(function () {
    clearTimers();
    activeRestore = null;
});
audio.addEventListener("ended", function () {
    if (!activeRestore) {
        return;
    }
    var restore = activeRestore;
    activeRestore = null;
    audio.src = restore.src;
    audio.currentTime = restore.currentTime;
    if (restore.wasPlaying) {
        audio.play();
    }
    timetableInterruptionFinished();
});
